var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"btn methodology-link d-flex",attrs:{"href":_vm.methodologyUrl,"target":"_blank"}},[_c('font-awesome-icon',{staticClass:"methodology-link__icon mr-md-2",attrs:{"icon":['fal', 'draw-circle']}}),_c('span',{staticClass:"d-none d-md-block"},[_vm._v(_vm._s(_vm.$t('general.methodology')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }